module.exports = __webpack_public_path__ + "img/green1.aa689879.jpg";